export default {
    parameters: {
        landing_id: "PLFCcs",
    },
    downtimeUrl: "https://it.kodland.tech",
    startPage: {
      image: "/welcome/quiz_project_girl.jpeg",
      title:
        "Otrzymaj limitowany dostęp do online kursu programowania dla swojego dziecka. W prezencie dajemy Ci również indywidualną lekcję próbną 1-1 z Twoim dzieckiem",
      subtitle:
        "Na lekcji i podczas kursu Twoje dziecko stworzy swój pierwszy projekt",
      button: "Zacznij teraz",
    },
    stopPage: {
        image: "/welcome/quiz_stop_page.jpg",
        title: "Dziękujemy za zaufanie do naszej platformy edukacyjnej! Niestety nasze lekcje mogą się odbywać tylko na komputerach, a tablety i telefony komórkowe nie są odpowiednie do odbycia naszych zajęć. Mamy jednak nadzieję, że zobaczymy się na naszych zajęciach innym razem!",
    },
    quizRotateBySteps: {
      1: {
        question: "Jak zazwyczaj Twoje dziecko spędza wolny czas?",
        answers: [
            "📱 Gra w gry na telefonie", 
            "💪 Uprawia sport",
            "👀 Ogląda bajki",
            "🎨 Kreatywnie spędza czas: rysuje, słucha muzyki, bawi się w aktora",
            "🤝 Spędza czas z przyjaciółmi",
        ],
      },
      2: {
        question: "Jaki przedmiot szkolny Twoje dziecko lubi najbardziej?",
        answers: [
            "🖥 Informatyka", 
            "🔢 Matematyka",
            "🎨 Plastyka, malarstwo i projektowanie",
            "📚 Literatura",
            "🗣 Języki obce",
            "❓ Nie jestem pewien/pewna",
        ],
      },
      3: {
        title: "Kiedy możesz uczestniczyć w lekcji próbnej?",
        type: "timeslot",
        subtitle:
          "Pozostało tylko kilka kroków, aby zapisać się na indywidualną lekcję! Wymagana jest obecność rodzica lub opiekuna prawnego, dlatego należy wybrać godzinę zgodną z Twoją dyspozycyjnością. Nie możemy się doczekać spotkania z Tobą🥳",
        button: "Dalej",
      },
      4: {
        question: "Czy Twoje dziecko posiada umiejętności komputerowe?",
        answers: [
          "🤝 Tak, korzysta z Microsoft Word/PowerPoint",
          "🎮 Tak, lubi grać w gry (Roblox, Minecraft).",
          "🖥 Tak, ma podstawowe umiejętności programowania",
          "🛑 Nie",
        ],
      },
      5: {
        question: "Czy posiadasz komputer stacjonarny/laptopa, z którego Twoje dziecko może skorzystać?",
        answers: [
          "✅ Tak",
          {
            answer: "❌ Nie",
            stopAnswer: true
          },
        ],
      },
      6: {
        title: "Ile lat ma Twoje dziecko?",
        type: "age",
        subtitle: "Dostosujemy najciekawszy kurs odpowiednio do wieku Twojego dziecka.  Zwracamy uwagę, że dziecko powinno posiadać umiejętność płynnego czytania, aby być w stanie w pełni uczestniczyć w lekcji",
        button: "Dalej",
      },
      7: {
        title: "Jak ma na imię Twoje dziecko?",
        type: "child_name",
        subtitle:
          "Dane są chronione i zostaną usunięte na Twoje życzenie 🚨",
        button: "Dalej",
      },
      8: {
        title: "Podaj swój adres e-mail",
        type: "mail",
        subtitle: "Nie martw się, nie dostaniesz niechcianych wiadomości 😅",
        button: "Dalej",
      },
      9: {
        title: "Podaj swój numer telefonu",
        type: "phone",
        subtitle: "Będziemy kontaktować z Tobą tylko w ważnych sprawach 📞",
        button: "Dalej",
      },
      10: {
        title: "Podaj swoje imię",
        type: "parent_name",
        subtitle: "Nasza szkoła to - Kodland, a Ty jak masz na imię? 👋",
        button: "Zakończyć rejestrację",
      },
    },
  };
  